import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import { ApiError } from '../services/apiClient';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing verification link. Check your email or request a new link from the app.');
      return;
    }
    let cancelled = false;
    (async () => {
      setStatus('loading');
      try {
        const res = await authService.verifyEmail(token);
        if (!cancelled) {
          setStatus('success');
          setMessage(res.message || 'Your email is verified.');
        }
      } catch (e) {
        if (!cancelled) {
          setStatus('error');
          if (e instanceof ApiError) {
            setMessage(typeof e.message === 'string' ? e.message : 'This link is invalid or expired.');
          } else {
            setMessage('Something went wrong. Try again from the app.');
          }
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="min-h-screen bg-app flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-surface rounded-2xl shadow-xl border border-border p-8 text-center">
        <div className="mx-auto h-16 w-16 bg-gradient-to-r from-primary to-primary-dark rounded-2xl flex items-center justify-center mb-4">
          <span className="text-2xl font-bold text-primary-fg">LP</span>
        </div>
        {status === 'loading' && <p className="text-fg">Verifying your email…</p>}
        {status === 'success' && (
          <>
            <h1 className="text-xl font-semibold text-fg mb-2">You&apos;re all set</h1>
            <p className="text-fg-secondary mb-6">{message}</p>
            <Link
              to="/login"
              className="inline-flex justify-center py-3 px-6 rounded-xl text-primary-fg bg-gradient-to-r from-primary to-primary-dark font-medium"
            >
              Sign in
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="text-xl font-semibold text-fg mb-2">Couldn&apos;t verify email</h1>
            <p className="text-fg-secondary mb-6">{message}</p>
            <Link to="/login" className="text-primary font-medium">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
